import styled from '@emotion/styled';

import { H3 } from '../H3/H3';
import { SecondaryTextColor } from '../styles/colors';

export const H2 = styled(H3)`
  margin-top: 2em;
  color: ${SecondaryTextColor};
  text-transform: uppercase;
`;



// WEBPACK FOOTER //
// ./src/components/LE/H2.js